import { PhotoProvider } from 'react-photo-view';
import { Group, Stack } from '@mantine/core';
import { MChatMessageAttachment } from '@/src/modules/chat/models/chat-message-attachment';

import 'react-photo-view/dist/react-photo-view.css';

import ChatAttachmentImageDownloadButton from './chat-attachment-utils/chat-attachment-image-download-button';
import { ChatAttachmentFile } from './chat-attachments/chat-attachment-file';
import ChatAttachmentImage from './chat-attachments/chat-attachment-image';

export interface IChatAttachmentGroupProps {
  size?: 'sm' | 'md';
  fromMe: boolean;
  attachments: MChatMessageAttachment[];
}

export function ChatAttachmentGroup({
  size = 'md',
  fromMe,
  attachments,
}: IChatAttachmentGroupProps) {
  const imageAttachments = attachments.filter(
    (attachment) => attachment.isImage
  );
  const imageAttachmentsIsNotEmpty = imageAttachments.length > 0;
  const fileAttachments = attachments.filter((attachment) => attachment.isFile);
  const fileAttachmentsIsNotEmpty = fileAttachments.length > 0;

  return (
    <Stack gap="xs">
      {imageAttachmentsIsNotEmpty && (
        <PhotoProvider
          toolbarRender={({ images, index }) => {
            const currentImage = images[index];
            return (
              <ChatAttachmentImageDownloadButton imageUrl={currentImage.src!} />
            );
          }}
        >
          <Group gap="0.3rem" justify={fromMe ? 'end' : 'start'}>
            {imageAttachments.map((attachment) => (
              <ChatAttachmentImage
                key={attachment.props.id}
                size={size}
                imageUrl={attachment.props.fileUrl}
                thumbnailUrl={
                  attachment.props.thumbnailUrl ?? attachment.props.fileUrl
                }
              />
            ))}
          </Group>
        </PhotoProvider>
      )}

      {fileAttachmentsIsNotEmpty && (
        <Group gap="0.3rem" justify={fromMe ? 'end' : 'start'}>
          {fileAttachments.map((attachment) => (
            <ChatAttachmentFile
              key={attachment.props.id}
              attachment={attachment}
            />
          ))}
        </Group>
      )}
    </Stack>
  );
}
